/**
 * useIsMobile — reactive mobile detection hook.
 *
 * Uses matchMedia with a 'change' listener so the value updates
 * live when the viewport crosses the breakpoint (resize, rotation).
 * Also checks for touch capability as a secondary signal.
 */
import { useState, useEffect } from 'react'

const MOBILE_BREAKPOINT = 640

export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches
            || 'ontouchstart' in window
    })

    useEffect(() => {
        const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`)
        const handler = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches || 'ontouchstart' in window)
        }
        mq.addEventListener('change', handler)
        return () => mq.removeEventListener('change', handler)
    }, [])

    return isMobile
}
